import { render, staticRenderFns } from "./InputFileComponent.vue?vue&type=template&id=3033801c&scoped=true"
import script from "./InputFileComponent.vue?vue&type=script&lang=js"
export * from "./InputFileComponent.vue?vue&type=script&lang=js"
import style0 from "./InputFileComponent.vue?vue&type=style&index=0&id=3033801c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3033801c",
  null
  
)

export default component.exports